import React = require('react');
import { IPolicyApplication } from '../../../../data/api/models';
import { filter, flow, forEach, get, head } from 'lodash';
import Loading from '../../../../components/Loading';
import { connect } from 'react-redux';
import { IStore } from '../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { withJob } from 'react-jobs';
import { IAuthState } from '../../../../services/auth/models';
import { IBrandingActions } from '../../../../services/branding/models';
import { IQuoteActions } from '../../../../services/quote/models';
import { useState } from 'react';
import { ApplicationDetailsBanner, applicationType } from '../Components/ApplicationDetailsBanner';
import { ApplicationOverview } from './Components/ApplicationOverview';
import { TravellersOverview } from '../Components/TravellersOverview';
import { OptionsOverview } from '../Components/OptionsOverview';
import { GoBack } from '../Components/GoBack';
import { WhatsCovered } from '../Components/WhatsCovered';

interface IQuoteDetails {
  auth: IAuthState;
  history: any;
  actions: {
    auth: IAuthActions;
    push: (route: string) => void;
    calculate: any;
    branding: IBrandingActions,
    quote: IQuoteActions;
  };
}

const QuoteDetail = ({ auth, actions, history }: IQuoteDetails) => {

  const [customerLapsed, setCustomerLapsed] = useState(false);
  const [isRetrievingQuote, setIsRetrievingQuote] = useState(false);

  const getSelectedQuote = (applications: IPolicyApplication[]) => {
    let selectedQuote = null;

    forEach(applications, (quoteSelected) => {
      if (location.pathname.match(quoteSelected.id)) {
        selectedQuote = quoteSelected;
      }
    });

    return selectedQuote;
  }

  const selectedQuote = getSelectedQuote(auth.customer.policyApplications);

  if (selectedQuote.status === 'customer lapsed') {
    setCustomerLapsed(true);
  }

  const documentsUrl = `/account/quotes/${selectedQuote.id}/documents`;

  const handleEditQuote = () => {

    setIsRetrievingQuote(true)
    Promise.resolve(actions.auth.retrieveExpiredQuote(selectedQuote.id)).then(() => {
      setIsRetrievingQuote(false)
    })
  }

  const selectedPremium = head(filter(selectedQuote.premiums, ['scheme.id', selectedQuote.schemeId])) || [];
  const referenceText = `Quote Reference ${selectedQuote.quoteReference}`
  const travellers = get(selectedQuote, 'travellers', []);
  const options = get(selectedQuote, 'options', []);
  const renderDetails = () => {
    return (
      <div>
        <div style={{ marginTop: '15px' }}/>

        <ApplicationDetailsBanner
          premium={selectedPremium}
          auth={auth}
          type={applicationType.QUOTED_DETAILS}
          documentsUrl={documentsUrl}
          text={referenceText}
          isRetrievingQuote={isRetrievingQuote}
          customerLapsed={customerLapsed}
          handleQuoteEdit={handleEditQuote}
        />

        <ApplicationOverview
          premium={selectedPremium}
          quote={selectedQuote}
        />

        <div style={{ marginTop: '15px' }}/>
        <TravellersOverview
          travellers={travellers}
        />

        <div style={{ marginTop: '15px' }}/>
        <OptionsOverview
          options={options}
        />

        <div style={{ marginTop: '15px' }}/>
        <WhatsCovered/>

        <div style={{ marginTop: '15px' }}/>
        <GoBack history={history}/>
      </div>
    )
  }

  return (
    <>
      {renderDetails()}
    </>
  )
}

export default flow([
  withJob({
    work: (props: IQuoteDetails) => {
      const promises = [];
      promises.push(props.actions.auth.reloadCustomer());
      return Promise.all(promises);
    },
    LoadingComponent: () => <Loading/>,
    ErrorComponent: ({ error }) => {
      console.error(error);
      return (
        <div>
          {error.message}
        </div>
      );
    },
  }),
  connect(
    (state: IStore) => {
      return {
        auth: state.auth,
        quote: state.quote,
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        auth: bindActionCreators({ ...authActions }, dispatch),
        quote: bindActionCreators({ ...quoteActions }, dispatch),
      },
    }),
  ),
])(QuoteDetail);
